import Encume from '../components/screens/encume/Encume'
import VallsEncume from '../components/screens/encume/vallsEncume/VallsEncume'
import Definition from '../components/screens/encume/definition/Definition'
import Offering from '../components/screens/encume/offer/Offering'
import NewsletterCTA from '../components/NewsletterCTA'

const CulturaMenstrualScreen = () => {
    return (
        <>
            <Encume /> 
            <Definition />
            <Offering />
            <VallsEncume />
            <NewsletterCTA />
        </>
    )
}

export default CulturaMenstrualScreen
